var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4105",
    "data-name": "Rectangle 4105",
    width: 15.395,
    height: 15.351,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11538",
    "data-name": "Group 11538",
    transform: "translate(-1320 -315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    transform: "translate(1320 315)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 15.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11212",
    "data-name": "Group 11212",
    transform: "translate(1329 324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11199",
    "data-name": "Group 11199",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M6.933,107.643v1.536H.887a.97.97,0,0,1-.518-.126.763.763,0,0,1-.09-1.24.953.953,0,0,1,.542-.169c.04,0,.08,0,.121,0Z",
    transform: "translate(0 -100.735)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M138.223,109.126a1.283,1.283,0,0,1-.387.067q-2.947.006-5.894,0h-.161V107.66h.166q2.947,0,5.894,0a1.357,1.357,0,0,1,.309.035.739.739,0,0,1,.567.669.754.754,0,0,1-.494.761",
    transform: "translate(-123.325 -100.752)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M109.581,6.742v7.73a1.078,1.078,0,0,1-.077.422.741.741,0,0,1-1.421-.21c-.014-.143-.022-.287-.022-.431q0-2.651,0-5.3V6.666q0-2.907,0-5.813a.821.821,0,0,1,.273-.667.707.707,0,0,1,.741-.135.712.712,0,0,1,.482.606,3.151,3.151,0,0,1,.023.419q0,2.833,0,5.666",
    transform: "translate(-101.126 0)",
    fill: "#0094d1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.8d1c3b31b9d0e57dad4b9f730c1878fa.svg";
export { ForwardRef as ReactComponent };